module.exports = __webpack_public_path__ + "de6b9b280abf0856a585a2421031045d.svg";